import { _ } from "~/route/globals";
import ItemEmpty from "~/route/item/empty";
import Items, { IItemData } from "~/route/items";
import { node } from "~/util/dom";
import { standardDistanceFormat, standardTimeFormat } from "~/util/format";
import { timeWithUserSpeed } from "~/util/user-speed";
import { getCriterion } from "~/util/route";

/**
 * Obal pro:
 * - vklada +
 */

export default class ItemPlus extends ItemEmpty {
	_hidden: boolean;

	_specialInsert: boolean;

	_item: any;

	_readOnly: boolean;

	/**
	 * Vytvoreni plus itemu.
	 *
	 * @param   parent
	 * @param   data
	 * @param   specialInsert Specialni insert - pubt/boat ho vkladaji az za sebe
	 */
	constructor(parent: Items, data: IItemData, specialInsert: boolean) {
		super(parent, data || {});

		this._hidden = true;
		this._specialInsert = specialInsert;
		this._item = null;
		this._readOnly = parent.readOnly;

		this._buildPlus();
		this._setHidden(true);
	}

	destroy() {
		super.destroy();
		this._dom.emptyCont.remove();
	}

	/**
	 * Zruseni editace.
	 */
	cancelEdit() {
		this._setHidden(true);
	}

	/**
	 * Nastaveni itemu - pri specialInsert.
	 *
	 * @param   {Item}  item
	 */
	set item(item) {
		this._item = item;
	}

	/**
	 * Vytvoreni - nesmi se jmenovat build, kvuli dedeni.
	 */
	_buildPlus() {
		const emptyCont = node("div", { className: "route-item-empty" });

		Array.from(this._dom.container.children).forEach(el => {
			emptyCont.appendChild(el);
		});

		this._dom.container.className = "route-item-plus";
		this._dom.emptyCont = emptyCont;

		if (this._readOnly) {
			this._dom.container.classList.add("read-only");
		}

		// skryjeme dad
		if (!this._readOnly) {
			this._dom.button = Mapy.Util.node("button", { className: "plus" });
			this._dom.button.addEventListener("click", () => {
				this._plusClick();
			});
			this._dom.container.appendChild(this._dom.button);
		}

		// mame routeData?
		if (this._data.routeData && this._data.routeData.length && this._data.routeData[Mapy.CML.state.route.index]) {
			const duration = [];

			if (this._data.routeData[Mapy.CML.state.route.index].length) {
				duration.push(standardDistanceFormat(this._data.routeData[Mapy.CML.state.route.index].length).string);
			}

			if (this._data.routeData[Mapy.CML.state.route.index].time) {
				duration.push(standardTimeFormat(timeWithUserSpeed(this._data.routeData[Mapy.CML.state.route.index].time, getCriterion())).string);
			}

			this._dom.container.appendChild(Mapy.Util.node("span", { className: "distance", textContent: duration.join(` ${_("route.ogContent")} `) }));
		}
	}

	/**
	 * Nastaveni stavu - jestli jde videt input nebo ne.
	 *
	 * @param  hidden  Novy stav
	 */
	_setHidden(hidden: boolean) {
		this._hidden = hidden;

		if (this._dom.button) {
			this._dom.button.textContent = this._hidden ? "+" : "c";
		}

		this._dom.container.classList[this._hidden ? "remove" : "add"]("open");

		const isSpecialInsert = this._specialInsert && this._item;

		if (this._hidden) {
			if (isSpecialInsert) {
				this._item.container.classList.remove("open-inserted");
				this._dom.container.classList.remove("open-inserted");
			}

			this._dom.emptyCont.remove();
		} else {
			if (isSpecialInsert) {
				this._parent.itemsList.insertBefore(this._dom.emptyCont, this._item.container.nextSibling);
				this._item.container.classList.add("open-inserted");
				this._dom.container.classList.add("open-inserted");
			} else {
				this._parent.itemsList.insertBefore(this._dom.emptyCont, this._dom.container.nextSibling);
			}
			this._suggestMapClick.input.focus();
		}
	}

	_plusClick() {
		this._setHidden(!this._hidden);
		this._parent.setEditState(this, !this._hidden);
	}

	_suggestMapClickCb(data) {
		this._setHidden(true);
		this._parent.setEditState(this, true);
		super._suggestMapClickCb(data);
	}
}
